import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
// 页面加载进度条
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import schoolLayout from '../views/school/TestPage.vue'
Vue.use(VueRouter);

const routes = [
  // 重定向
  {
    path: "/",
    name: "index",
    // component: () => import('../views/edu/eduIndex.vue'),
    meta: {
      title: "首页", // 标题
      isLogin: true, // 是否要登录
      webType: 3 // 页面归类,1学校，2教育局
    }
  },
  {
    path: "/",
    component: schoolLayout,
    children: [
      {
        path: '/newHome',
        name: "newHome",
        component: () => import('../views/newHome.vue'),
        meta: {
          title: "school首页", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        },
      }
    ]
  },

  // 教育局首页
  {
    path: "/eduIndex",
    name: "eduIndex",
    component: () => import("../views/edu/eduIndex.vue"),
    meta: {
      title: "教育机构首页", // 标题
      isLogin: true, // 是否要登录
      webType: 2 // 页面归类,1学校，2教育局
    },
    children: [
      {
        path: "/EVisualization",
        name: "EVisualization",
        component: () =>
          import(
            "../views/edu/customVideo/index.vue"
          ),
        meta: {
          title: "", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },
      {
        path: "/cloud_meetingEdu",
        name: "cloud_meetingEdu",
        component: () =>
          import(
            "../views/school/cloudMeeting/index.vue"
          ),
        meta: {
          title: "云上会议", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },
      //安全物联设备管理
      // {
      //   path: "/bureauofeducation/device_management",
      //   name: "device_management",
      //   component: () =>
      //     import(
      //      "../views/bureauofeducation/device/index.vue"
      //     ),
      //   meta: {
      //     title: "设备管理", // 标题
      //     isLogin: true, // 是否要登录
      //     webType: 2 // 页面归类,1学校，2教育局
      //   }
      // },
    //安全物联报警信息
    // {
    //   path: "/bureauofeducation/callthepolice_list",
    //   name: "callthepolice_list",
    //   component: () =>
    //     import(
    //      "../views/bureauofeducation/callthepolice/index.vue"
    //     ),
    //   meta: {
    //     title: "报警信息", // 标题
    //     isLogin: true, // 是否要登录
    //     webType: 2 // 页面归类,1学校，2教育局
    //   }
    // },
      {
        path: "/enterprise_list",
        name: "enterprise_list",
        component: () =>
          import(
            "../views/edu/enteprise/index.vue"
          ),
        meta: {
          title: "研学监管", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },
      {
        path: "/ente_camera",
        name: "ente_camera",
        component: () =>
          import(
            "../views/edu/enteCamera/index.vue"
          ),
        meta: {
          title: "护学监督", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },
      {
        path: "/stop_catch_camera",
        name: "stop_catch_camera",
        component: () =>
          import(
            "../views/edu/stopCatchCamera/index.vue"
          ),
        meta: {
          title: "违停抓拍", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },
      {
        path: "/cloudPlanEdu",
        name: "cloudPlanEdu",
        component: () => import("../views/school/device/planEdu.vue"),
        meta: {
          title: "应急预案", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },
      // 基础信息编辑
      {
        path: "/group_basic_info",
        name: "group_basic_info",
        component: () => import("../views/edu/eduData/eduData.vue"),
        meta: {
          title: "基础信息", // 标题
          parent:"安全资料",
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },

      // 职务管理
      {
        path: "/edu_duties",
        name: "edu_duties",
        component: () => import("../views/edu/eduData/eduDuties.vue"),
        meta: {
          title: "职务管理", // 标题
          parent:"安全资料",
          // title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },

      // 角色成员
      {
        path: "/edu_role_member",
        name: "edu_role_member",
        component: () => import("../views/edu/eduData/eduRoleMember.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },

      // 角色授权
      {
        path: "/edu_role_authority",
        name: "edu_role_authority",
        component: () => import("../views/edu/eduData/eduRoleAuthority.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },

      // 权限管理
      {
        path: "/edu_authority",
        name: "edu_authority",
        component: () => import("../views/edu/eduData/eduAuthority.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },

      // 机构用户
      {
        path: "/edu_user",
        name: "edu_user",
        component: () => import("../views/edu/eduData/eduUser.vue"),
        meta: {
          title: "人员信息", // 标题
          parent:"安全资料",
          // title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },

      // 部门管理
      {
        path: "/edu_department",
        name: "edu_department",
        component: () => import("../views/edu/eduData/eduDepartment.vue"),
        meta: {
          // title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          title: "部门管理", // 标题
          parent:"安全资料",
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },

      // 下属机构管理
      {
        path: "/subsidiaries",
        name: "subsidiaries",
        component: () => import("../views/edu/eduData/subsidiaries.vue"),
        meta: {
          title: "下属机构", // 标题
          parent:"安全资料",
          // title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },

      // 下属学校管理
      {
        path: "/subordinate_school",
        name: "subordinate_school",
        component: () => import("../views/edu/eduData/SubordinateSchool.vue"),
        meta: {
          // title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          title: "下属学校", // 标题
          parent:"安全资料",
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },

      // 院系管理
      {
        path: "/un_subordinate_school",
        name: "un_subordinate_school",
        component: () => import("../views/edu/eduData/UnSubordinateSchool.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },

      // 下属街道
      {
        path: "/bureau_edu",
        name: "bureau_edu",
        component: () => import("../views/edu/eduData/bureauEdu.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },

      // 督办小组
      {
        path: "/supervision_group",
        name: "supervision_group",
        component: () => import("../views/edu/eduData/supervisionGroup.vue"),
        meta: {
          // title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          title: "督办小组", // 标题
          parent:"安全资料",
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },

      // 专项检查任务
      {
        path: "/special_inspect_task",
        name: "special_inspect_task",
        component: () =>
          import("../views/edu/safetyManagement/eduSpecialInspect.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },
      // 消息通知
      {
        path: "/task_notices",
        name: "taskNotices",
        component: () =>
          import(
            "../views/edu/safetyManagement/notices/index.vue"
          ),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },
      // // 上级通知
      // {
      //   path: "/task_notices_up",
      //   name: "task_notices_up",
      //   component: () =>
      //     import(
      //       "../views/edu/safetyManagement/notices/notices.vue"
      //     ),
      //   meta: {
      //     title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
      //     isLogin: true, // 是否要登录
      //     webType: 2 // 页面归类,1学校，2教育局
      //   }
      // },
      // 任务下发
      {
        path: "/task_issue_manage",
        name: "taskIssueManage",
        component: () =>
          import(
            "../views/edu/safetyManagement/taskIssueManage/taskIssueManage.vue"
          ),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },

      // 校内隐患
      {
        path: "/eduHiddenDangerWarning",
        name: "eduHiddenDangerWarning",
        component: () =>
          import(
            "../views/edu/safetyManagement/hiddenDanger/hiddenDangerWarning.vue"
          ),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },

      // 校内隐患
      {
        path: "/eduHiddenDangerData",
        name: "eduHiddenDangerData",
        component: () =>
          import(
            "../views/edu/safetyManagement/hiddenDanger/hiddenDangerData.vue"
          ),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },
      

      // 教育局隐患督办
      {
        path: "/eduHiddenDangerSupervise",
        name: "eduHiddenDangerSupervise",
        component: () =>
          import(
            "../views/edu/safetyManagement/hiddenDanger/hiddenDangerSupervise.vue"
          ),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },

      // 校长专栏
      {
        path: "/eduPrincipalColumn",
        name: "eduPrincipalColumn",
        component: () =>
          import(
            "../views/edu/safetyManagement/principalColumn/index.vue"
          ),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },

      // 事故管理
      {
        path: "/SafetyAccident",
        name: "SafetyAccident",
        component: () =>
          import(
            "../views/edu/safetyManagement/safetyAccident/SafetyAccident.vue"
          ),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },
      
      

      // 专项检查项目
      {
        path: "/edu_inspect_project",
        name: "edu_inspect_project",
        component: () =>
          import("../views/edu/safetyManagement/eduSpecialInspectProject.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },
      // 护学岗 => 人员管理
      {
        path: "/NursingPost",
        name: "NursingPost",
        component: () =>
          import(
            "../views/edu/safetyManagement/hiddenDanger/NursingPost.vue"
          ),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },

      // 护学岗 => 护学记录
      {
        path: "/NursingPostList",
        name: "NursingPostList",
        component: () =>
          import(
            "../views/edu/safetyManagement/hiddenDanger/NursingPostList.vue"
          ),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },
      // 问卷调查
      {
        path: "/questionnaire_survey_manage",
        name: "questionnaire_survey_manage",
        component: () =>
          import(
            "../views/edu/safetyManagement/questionnaireSurvey/QuestionnaireSurveyManage.vue"
          ),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },

      // 问卷调查(新)
      {
        path: "/questionnaire_survey",
        name: "questionnaire_survey",
        component: () =>
          import(
            "../views/edu/safetyManagement/questionnaireSurvey/questionnaireSurvey.vue"
          ),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        },
        children: [
          // 问卷调查(新)--详情
          {
            path: "/questionnaire_survey_detail",
            name: "questionnaire_survey_detail",
            component: () =>
              import(
                "../views/edu/safetyManagement/questionnaireSurvey/components/QuestionnaireSurveyDetail.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 2 // 页面归类,1学校，2教育局
            }
          },
          // 问卷调查(新)--新增以及编辑
          {
            path: "/questionnaire_survey_add_or_edit",
            name: "questionnaire_survey_add_or_edit",
            component: () =>
              import(
                "../views/edu/safetyManagement/questionnaireSurvey/components/QuestionnaireSurveyAddOrEdit.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 2 // 页面归类,1学校，2教育局
            }
          }
        ]
      },

      // 教育局-安全台账-导出隐患数据
      {
        path: "/hidden_export",
        name: "hidden_export",
        component: () =>
          import(
            "../views/edu/safetyAccount/hiddenDanger/index.vue"
          ),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },

      // 教育局-安全台账-导出巡查数据
      {
        path: "/patrol_export",
        name: "patrol_export",
        component: () =>
          import(
            "../views/edu/safetyAccount/patrol/index.vue"
          ),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },

      // 绩效考核规则
      {
        path: "/inspection_rules",
        name: "inspection_rules",
        component: () =>
          import(
            "../views/edu/safetyAccount/performanceEvaluation/inspectionRules.vue"
          ),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },

      // 后勤总公司---人员信息
      {
        path: "/l_user_data",
        name: "l_user_data",
        component: () => import("../views/logistics/safetyData/UserData.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },

      // 后勤总公司---下属机构
      {
        path: "/l_subordinate_body",
        name: "l_subordinate_body",
        component: () =>
          import("../views/logistics/safetyData/SubordinateBody.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },

      // 后勤总公司---安全小组
      {
        path: "/l_security_group",
        name: "l_security_group",
        component: () =>
          import("../views/logistics/safetyData/SecurityGroup.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },
      // 后勤总公司---管理的院系
      {
        path: "/l_colleges",
        name: "l_colleges",
        component: () => import("../views/logistics/hiddenDanger/colleges.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },
      // 后勤总公司---隐患管理
      {
        path: "/l_hidden_Danger",
        name: "l_hidden_Danger",
        component: () =>
          import("../views/logistics/hiddenDanger/hiddenDanger.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },
      {
        path: "/online",
        name: "online",
        component: () =>
          import("../views/edu/online.vue"),
        meta: {
          title: "直播", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },
      // {
      //   path: "/fireFighting",
      //   name: "fireFighting",
      //   component: () =>
      //     import("../views/edu/eduData/ProtectAlarmManagement.vue"),
      //   meta: {
      //     title: "智慧消防", // 标题
      //     isLogin: true, // 是否要登录
      //     webType: 2 // 页面归类,1学校，2教育局
      //   }
      // },
      
      // {
      //   path: "/onlineAdd",
      //   name: "onlineAdd",
      //   component: () =>
      //     import("../views/ChartRoom/onlineAdd.vue"),
      //   meta: {
      //     title: "直播", // 标题
      //     isLogin: true, // 是否要登录
      //     webType: 2 // 页面归类,1学校，2教育局
      //   }
      // },
    ]
  },
  // 教育局大数据中心-v1
  {
    path: "/sanMen",
    name: "sanMen",
    component: () =>
      import("../views/edu/bigData/v1/sanMen.vue"),
    meta: {
      title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
      isLogin: true, // 是否要登录
      webType: 2 // 页面归类,1学校，2教育局
    }
  },
   // 智慧消防
   {
    path: "/fireFighting",
    name: "fireFighting",
    component: () =>
      import("../views/edu/bigData/v1/fireFighting.vue"),
    meta: {
      title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
      isLogin: true, // 是否要登录
      webType: 2 // 页面归类,1学校，2教育局
    }
  },
  {
    path: "/demo",
    name: "demo",
    component: () =>
      import("../views/ChartRoom/demo/index.vue"),
    meta: {
      title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
      isLogin: true, // 是否要登录
      webType: 2 // 页面归类,1学校，2教育局
    }
  },
  // {
  //   path: "/fireFighting",
  //   name: "fireFighting",
  //   component: () =>
  //     import("../views/edu/eduData/ProtectAlarmManagement.vue"),
  //   meta: {
  //     title: "智慧消防", // 标题
  //     isLogin: true, // 是否要登录
  //     webType: 2 // 页面归类,1学校，2教育局
  //   }
  // },
   // 直播
 
  {
    path: "/bigData",
    name: "bigData",
    component: () => import("../views/edu/bigData/v1/index.vue"),
    meta: {
      title: "大数据中心", // 标题
      isLogin: true, // 是否要登录
      webType: 2 // 页面归类,1学校，2教育局
    },
    children: [
     
      // 安全态势
      {
        path: "/eduSecuritySituation_1",
        name: "eduSecuritySituation_1",
        component: () =>
          import("../views/edu/bigData/v1/eduSecuritySituation.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },
      // 风险统计
      {
        path: "/eduRiskStatistics",
        name: "eduRiskStatistics",
        component: () => import("../views/edu/bigData/v1/eduRiskStatistics.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },
      // 隐患统计
      {
        path: "/eduHiddenDangerStatistics",
        name: "eduHiddenDangerStatistics",
        component: () =>
          import("../views/edu/bigData/v1/eduHiddenDangerStatistics.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },
      // 档案统计
      {
        path: "/eduFilesStatistics",
        name: "eduFilesStatistics",
        component: () => import("../views/edu/bigData/v1/eduFilesStatistics.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },
      // 安全中心
      {
        path: "/eduSafetyCenter",
        name: "eduSafetyCenter",
        component: () => import("../views/edu/bigData/v1/eduSafetyCenter.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },
      // 安全地图
      {
        path: "/eduSafetyMap",
        name: "eduSafetyMap",
        component: () => import("../views/edu/bigData/v1/eduSafetyMap.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      }
    ]
  },
  // 教育局大数据中心-v2
  {
    path: "/bigData_2",
    name: "bigData_2",
    component: () => import("../views/edu/bigData/v2/index.vue"),
    meta: {
      title: "大数据中心", // 标题
      isLogin: true, // 是否要登录
      webType: 2 // 页面归类,1学校，2教育局
    },
    children: [
      // 安全态势
      {
        path: "/eduSecuritySituation_2",
        name: "eduSecuritySituation_2",
        component: () =>
          import("../views/edu/bigData/v2/eduSecuritySituation.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },
      // 风险统计
      {
        path: "/eduRiskStatistics_2",
        name: "eduRiskStatistics_2",
        component: () => import("../views/edu/bigData/v2/eduRiskStatistics.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },
      // 隐患统计
      {
        path: "/eduHiddenDangerStatistics_2",
        name: "eduHiddenDangerStatistics_2",
        component: () =>
          import("../views/edu/bigData/v2/eduHiddenDangerStatistics.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },
      // 档案统计
      {
        path: "/eduFilesStatistics_2",
        name: "eduFilesStatistics_2",
        component: () => import("../views/edu/bigData/v2/eduFilesStatistics.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },
      // 安全中心
      {
        path: "/eduSafetyCenter_2",
        name: "eduSafetyCenter_2",
        component: () => import("../views/edu/bigData/v2/eduSafetyCenter.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },
      // 安全地图
      {
        path: "/eduSafetyMap_2",
        name: "eduSafetyMap_2",
        component: () => import("../views/edu/bigData/v2/eduSafetyMap.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      }
    ]
  },

  // 高校大数据中心
  {
    path: "/universityBigData",
    name: "universityBigData",
    component: () => import("../views/edu/universityBigData/index.vue"),
    meta: {
      title: "大数据中心", // 标题
      isLogin: true, // 是否要登录
      webType: 2 // 页面归类,1学校，2教育局
    },
    children: [
      // 安全态势
      {
        path: "/unSecuritySituation",
        name: "unSecuritySituation",
        component: () =>
          import("../views/edu/universityBigData/unSecuritySituation.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },
      // 风险统计
      {
        path: "/unRiskStatistics",
        name: "unRiskStatistics",
        component: () => import("../views/edu/bigData/v1/eduRiskStatistics.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },
      // 隐患统计
      {
        path: "/unHiddenDangerStatistics",
        name: "unHiddenDangerStatistics",
        component: () =>
          import("../views/edu/bigData/v1/eduHiddenDangerStatistics.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      },
      // 档案统计
      {
        path: "/unFilesStatistics",
        name: "unFilesStatistics",
        component: () =>
          import("../views/edu/universityBigData/unFilesStatistics.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 2 // 页面归类,1学校，2教育局
        }
      }
    ]
  },
  // 高校大数据中心(新)
  {
    path: "/newUniversityBigData",
    name: "newUniversityBigData",
    component: () => import("../views/edu/newUniversityBigData/index.vue"),
    meta: {
      title: "大数据中心", // 标题
      isLogin: true, // 是否要登录
      webType: 2 // 页面归类,1学校，2教育局
    },
    children: []
  },

  // 学校首页
  {
    path: "/schoolIndex_1",
    name: "schoolIndex_1",
    component: () => import("../views/school/schoolIndex1.vue"),
    meta: {
      title: "首页", // 标题
      isLogin: true, // 是否要登录
      webType: 1 // 页面归类,1学校，2教育局
    }
  },
  // 学校首页
  {
    path: "/schoolIndex_2",
    name: "schoolIndex_2",
    component: () => import("../views/school/schoolIndex2.vue"),
    meta: {
      title: "首页", // 标题
      isLogin: true, // 是否要登录
      webType: 1 // 页面归类,1学校，2教育局
    }
  },

  // 操作指南
  {
    path: "/operation_guide",
    name: "operation_guide",
    component: () =>
      import("../views/school/operationGuide/OperationGuide.vue"),
    meta: {
      title: "平台操作指南", // 标题
      isLogin: true, // 是否要登录
      webType: 1 // 页面归类,1学校，2教育局
    }
  },

  // app下载
  {
    path: "/app_downLoad",
    name: "app_downLoad",
    component: () => import("../views/school/appDownLoad/AppDownLoad.vue"),
    meta: {
      title: "应用下载中心", // 标题
      isLogin: true, // 是否要登录
      webType: 1 // 页面归类,1学校，2教育局
    }
  },

  // 测试页面
  {
    path: "/test_page",
    name: "test_page",
    component: () => import("../views/school/TestPage.vue"),
    meta: {
      title: "建议反馈", // 标题
      isLogin: true, // 是否要登录
      webType: 1 // 页面归类,1学校，2教育局
    }
  },
  // 学校内容
  {
    // 学校页面(旧)
    // path: '/schoolPage',
    // component: () => import('../views/school/EnterprisePage.vue'),

    // 学校页面(新)
    path: "/test_page",
    name: "test_page",
    component: () => import("../views/school/TestPage.vue"),
    meta: {
      title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
      isLogin: true, // 是否要登录
      webType: 1 // 页面归类,1学校，2教育局
    },
    children: [
      {
        path: "/home_page",
        name: "home_page",
        component: () => import("../views/school/homePage/HomePage.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        }
      },
      //风险辨识管控
      {
        path: "/risk",
        name: "risk",
        component: () => import("../views/school/riskIdentification/Risk.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        },
        children: [
          // 工作领导小组
          {
            path: "/leading_group",
            name: "leading_group",
            component: () =>
              import("../views/school/riskIdentification/LeadingGroup.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },
          // 风险清单模型
          {
            path: "/risk_list_model",
            name: "risk_list_model",
            component: () =>
              import("../views/school/riskIdentification/RiskListModel.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 风险辨识
          {
            path: "/risk_identification",
            name: "risk_identification",
            component: () =>
              import(
                "../views/school/riskIdentification/RiskIdentification.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 风险评估
          {
            path: "/risk_assessment",
            name: "risk_assessment",
            component: () =>
              import("../views/school/riskIdentification/RiskAssessment.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 分级管控清单
          {
            path: "/hierarchical_control_list",
            name: "hierarchical_control_list",
            component: () =>
              import(
                "../views/school/riskIdentification/HierarchicalControlList.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 风险告知卡
          {
            path: "/risk_notification_card",
            name: "risk_notification_card",
            component: () =>
              import(
                "../views/school/riskIdentification/RiskNotificationCard.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 展板
          {
            path: "/risk_notification_board",
            name: "risk_notification_board",
            component: () =>
              import(
                "../views/school/riskIdentification/RiskNotificationBoard.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 重大风险点公告
          {
            path: "/risk_notice",
            name: "risk_notice",
            component: () =>
              import("../views/school/riskIdentification/RiskNotice.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 重大风险点公告
          {
            path: "/notice_template",
            name: "notice_template",
            component: () =>
              import(
                "../views/school/riskIdentification/RiskNoticeTemplate.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 风险比较四色图
          {
            path: "/risk_compare_chart",
            name: "risk_compare_chart",
            component: () =>
              import("../views/school/riskIdentification/RiskCompareChart.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },
          //等级四色图列表
          {
            path: "/grade_chart_list",
            name: "grade_chart_list",
            component: () =>
              import("../views/school/riskIdentification/GradeChartList.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },
          //等级四色图详情
          {
            path: "/grade_chart_details",
            name: "grade_chart_details",
            component: () =>
              import(
                "../views/school/riskIdentification/GradeChartDetails.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 制度建设资料
          {
            path: "/RiskInstitutionalBuilding",
            name: "RiskInstitutionalBuilding",
            component: () =>
              import(
                "../views/school/riskIdentification/RiskInstitutionalBuilding.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 安全风险单元
          {
            path: "/RiskUnitDivision",
            name: "RiskUnitDivision",
            component: () =>
              import(
                "../views/school/riskIdentification/RiskUnitDivision.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 危险源辨识及风险分析
          {
            path: "/RiskIdentificationAnalysis",
            name: "RiskIdentificationAnalysis",
            component: () =>
              import(
                "../views/school/riskIdentification/RiskIdentificationAnalysis.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 风险点清单
          {
            path: "/RiskInventoryList",
            name: "RiskInventoryList",
            component: () =>
              import(
                "../views/school/riskIdentification/RiskInventoryList.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 风险管控台账
          {
            path: "/risk_control_account",
            name: "risk_control_account",
            component: () =>
              import(
                "../views/school/riskIdentification/RiskControlAccount.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 风险管控责任清单
          {
            path: "/RiskControlList",
            name: "RiskControlList",
            component: () =>
              import(
                "../views/school/riskIdentification/RiskControlList.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 安全风险数据库
          {
            path: "/RiskDatabase",
            name: "RiskDatabase",
            component: () =>
              import(
                "../views/school/riskIdentification/RiskDatabase.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 隐患排查表
          {
            path: "/RiskHiddenDanger",
            name: "RiskHiddenDanger",
            component: () =>
              import(
                "../views/school/riskIdentification/RiskHiddenDanger.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          }
        ]
      },

      //隐患排查治理
      {
        path: "/hidden_danger",
        name: "hidden_danger",
        component: () =>
          import("../views/school/hiddenDanger/HiddenDanger.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        },
        children: [
          //隐患数据
          {
            path: "/hidden_danger_data",
            name: "hidden_danger_data",
            component: () =>
              import("../views/school/hiddenDanger/HiddenDangerData.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // //隐患数据(列表)
          // {
          //     path: '/hidden_danger_data_list',
          //     name: 'hidden_danger_data_list',
          //     component: () => import('../views/school/hiddenDanger/HiddenDangerDataList.vue'),
          //     meta: {
          //         title: '安全风险辨识管控与隐患排查治理双重预防体系云平台',  // 标题
          //         isLogin:true,  // 是否要登录
          //         webType:1,  // 页面归类,1学校，2教育局
          //     },
          //     hidden: false,
          //     children:[
          //         //隐患详情
          //         {
          //             path: '/hidden_danger_data_detail',
          //             name: 'hidden_danger_data_detail',
          //             component: () => import('../views/school/hiddenDanger/HiddenDangerDataDetail.vue'),
          //             meta: {
          //                 title: '安全风险辨识管控与隐患排查治理双重预防体系云平台',  // 标题
          //                 isLogin:true,  // 是否要登录
          //                 webType:1,  // 页面归类,1学校，2教育局
          //             },
          //             hidden: true
          //         },
          //         //上报隐患
          //         {
          //             path: '/hidden_danger_data_add',
          //             name: 'hidden_danger_data_add',
          //             component: () => import('../views/school/hiddenDanger/HiddenDangerDataAdd.vue'),
          //             meta: {
          //                 title: '安全风险辨识管控与隐患排查治理双重预防体系云平台',  // 标题
          //                 isLogin:true,  // 是否要登录
          //                 webType:1,  // 页面归类,1学校，2教育局
          //             },
          //             hidden: true
          //         },
          //     ]

          // },
          //隐患督办
          {
            path: "/hidden_danger_supervise",
            name: "hidden_danger_supervise",
            component: () =>
              import("../views/school/hiddenDanger/HiddenDangerSupervise.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },
          //隐患预设地点
          {
            path: "/hidden_danger_preset_location",
            name: "hidden_danger_preset_location",
            component: () =>
              import(
                "../views/school/hiddenDanger/HiddenDangerPresetLocation.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },
          //隐患分类管理
          {
            path: "/hidden_danger_classification",
            name: "hidden_danger_classification",
            component: () =>
              import(
                "../views/school/hiddenDanger/HiddenDangerClassification.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 维修管理
          {
            path: "/repair_data",
            name: "repair_data",
            component: () =>
              import("../views/school/hiddenDanger/RepairData.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          //巡查区域
          {
            path: "/patrol_area",
            name: "patrol_area",
            component: () =>
              import("../views/school/hiddenDanger/PatrolArea.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },
          //规避时间设置
          {
            path: "/circumvention_time_setting",
            name: "circumvention_time_setting",
            component: () =>
              import(
                "../views/school/hiddenDanger/CircumventionTimeSetting.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          {
            path: "/AvoidTimeSetting",
            name: "AvoidTimeSetting",
            component: () =>
              import("../views/school/hiddenDanger/AvoidTimeSetting.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          //巡查任务
          {
            path: "/patrol_task",
            name: "patrol_task",
            component: () =>
              import("../views/school/hiddenDanger/PatrolTask.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },
          //巡查记录
          {
            path: "/patrol_record",
            name: "patrol_record",
            component: () =>
              import("../views/school/hiddenDanger/PatrolRecord.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          //巡查值班
          {
            path: "/patrol_duty",
            name: "patrol_duty",
            component: () =>
              import("../views/school/hiddenDanger/PatrolDuty.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          //定位巡查
          {
            path: "/patrol_location",
            name: "patrol_location",
            component: () =>
              import("../views/school/hiddenDanger/PatrolLocation.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          //定位巡查记录
          {
            path: "/patrol_location_record",
            name: "patrol_location_record",
            component: () =>
              import("../views/school/hiddenDanger/PatrolLocationRecord.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          }
        ]
      },

      //事故应急处理
      {
        path: "/emergency_treatment",
        name: "emergency_treatment",
        component: () =>
          import("../views/school/emergencyTreatment/EmergencyTreatment.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        },
        children: [
          //安全事故
          {
            path: "/safety_accident",
            name: "safety_accident",
            component: () =>
              import("../views/school/emergencyTreatment/SafetyAccident.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          //应急预案
          {
            path: "/emergency_plan",
            name: "emergency_plan",
            component: () =>
              import("../views/school/emergencyTreatment/EmergencyPlan.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },



          //公共预案库
          {
            path: "/public_plan_library",
            name: "public_plan_library",
            component: () =>
              import(
                "../views/school/emergencyTreatment/PublicPlanLibrary.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          //演练记录
          {
            path: "/drill_record",
            name: "drill_record",
            component: () =>
              import("../views/school/emergencyTreatment/DrillRecord.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          //演练疏散图
          {
            path: "/drill_evacuation_map",
            name: "drill_evacuation_map",
            component: () =>
              import(
                "../views/school/emergencyTreatment/DrillEvacuationMap.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          //应急救援器材
          {
            path: "/emergency_rescue_equipment",
            name: "emergency_rescue_equipment",
            component: () =>
              import(
                "../views/school/emergencyTreatment/EmergencyRescueEquipment.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          }
        ]
      },

      // 基本信息
      {
        path: "/schoole_info",
        name: "schoole_info",
        component: () => import("../views/school/SchoolInfo.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        }
      },
      // 校园态势编辑（大数据编辑）
      {
        path: "/situation_editor",
        name: "situation_editor",
        component: () =>
          import("../views/school/safetyData/SituationEditor.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        }
      },
      // 帮助
      {
        path: "/help_page",
        name: "help_page",
        component: () => import("../views/school/helpPage/HelpPage.vue"),
        meta: {
          title: "帮助", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        }
      },
      // 通知
      {
        path: "/help_notices",
        name: "help_notices",
        component: () => import("../views/school/helpPage/notices.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        }
      },

      // 学校资料
      {
        path: "/schoolData",
        name: "schoolData",
        component: () => import("../views/school/schoolData/index.vue"),
        meta: {
          title: "学校资料", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        }
      },
      // 建议反馈
      {
        path: "/advice_feedback",
        name: "advice_feedback",
        component: () =>
          import("../views/school/adviceFeedback/AdviceFeedback.vue"),
        meta: {
          title: "建议反馈", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        }
      },
      // 安全资料
      {
        path: "/security_data",
        name: "security_data",
        component: () => import("../views/school/safetyData/SecurityData.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        },
        children: [
          // 修改学校基本信息
          {
            path: "/update_school_data",
            name: "update_school_data",
            component: () =>
              import("../views/school/safetyData/UpdateSchoolData.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },
          // 校园态势编辑
          // {
          //     path: '/situation_editor',
          //     name: 'situation_editor',
          //     component: () => import('../views/school/safetyData/SituationEditor.vue'),
          //     meta: {
          //         title: '安全风险辨识管控与隐患排查治理双重预防体系云平台',  // 标题
          //         isLogin:true,  // 是否要登录
          //         webType:1,  // 页面归类,1学校，2教育局
          //     },
          // },

          // 权限设置
          {
            path: "/authority_settings",
            name: "authority_settings",
            component: () =>
              import(
                "../views/school/safetyData/personnelBasicData/AuthoritySettings.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 角色成员 (成员管理)
          {
            path: "/role_member",
            name: "role_member",
            component: () =>
              import(
                "../views/school/safetyData/personnelBasicData/RoleMember.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 访问权限
          {
            path: "/access_authority",
            name: "access_authority",
            component: () =>
              import(
                "../views/school/safetyData/personnelBasicData/AccessAuthority.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 短信推送权限
          {
            path: "/message_authority",
            name: "message_authority",
            component: () =>
              import(
                "../views/school/safetyData/personnelBasicData/MessageAuthority.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 部门管理
          {
            path: "/department_management",
            name: "department_management",
            component: () =>
              import(
                "../views/school/safetyData/personnelBasicData/DepartmentManagement.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 部门用户
          {
            path: "/department_user",
            name: "department_user",
            component: () =>
              import(
                "../views/school/safetyData/personnelBasicData/DepartmentUser.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 班级管理
          {
            path: "/class_management",
            name: "class_management",
            component: () =>
              import(
                "../views/school/safetyData/personnelBasicData/ClassManagement.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 班级摄像头
          {
            path: "/class_camera",
            name: "class_camera",
            component: () =>
              import(
                "../views/school/safetyData/personnelBasicData/ClassCamera.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 班级老师
          {
            path: "/class_teacher",
            name: "class_teacher",
            component: () =>
              import(
                "../views/school/safetyData/personnelBasicData/ClassTeacher.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 班级学生
          {
            path: "/class_student",
            name: "class_student",
            component: () =>
              import(
                "../views/school/safetyData/personnelBasicData/ClassStudent.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 安全小组--隐患小组
          {
            path: "/security_group",
            name: "security_group",
            component: () =>
              import(
                "../views/school/safetyData/personnelBasicData/SecurityGroup.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 安全小组--报修小组
          {
            path: "/repairs_group",
            name: "repairs_group",
            component: () =>
              import(
                "../views/school/safetyData/personnelBasicData/RepairsGroup.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 职务管理
          {
            path: "/job_management",
            name: "job_management",
            component: () =>
              import(
                "../views/school/safetyData/personnelBasicData/JobManagement.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 宿舍楼管理
          {
            path: "/apartmentBuilding",
            name: "apartmentBuilding",
            component: () =>
              import(
                "../views/school/safetyData/personnelBasicData/apartmentBuilding.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },
          // 宿舍房间
          {
            path: "/apartmentRooms",
            name: "apartmentRooms",
            component: () =>
              import(
                "../views/school/safetyData/personnelBasicData/apartmentRooms.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },
          // 宿舍人员
          {
            path: "/apartmentPersons",
            name: "apartmentPersons",
            component: () =>
              import(
                "../views/school/safetyData/personnelBasicData/apartmentPersons.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 教师信息
          {
            path: "/teacher_data",
            name: "teacher_data",
            component: () =>
              import(
                "../views/school/safetyData/personnelBasicData/TeacherData.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 学生信息
          {
            path: "/student_data",
            name: "student_data",
            component: () =>
              import(
                "../views/school/safetyData/personnelBasicData/StudentData.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 家长信息
          {
            path: "/parents_data",
            name: "parents_data",
            component: () =>
              import(
                "../views/school/safetyData/personnelBasicData/ParentsData.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 安保档案填报
          {
            path: "/security_archives",
            name: "security_archives",
            component: () =>
              import(
                "../views/school/safetyData/securityArchives/SecurityArchives.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 消防档案填报
          {
            path: "/fire_archives",
            name: "fire_archives",
            component: () =>
              import(
                "../views/school/safetyData/securityArchives/FireArchives.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 校车档案填报
          {
            path: "/schoolbus_archives",
            name: "schoolbus_archives",
            component: () =>
              import(
                "../views/school/safetyData/securityArchives/SchoolBusArchives.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 器械档案填报
          {
            path: "/apparatus_archives",
            name: "apparatus_archives",
            component: () =>
              import(
                "../views/school/safetyData/securityArchives/ApparatusArchives.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 特异体质学生档案
          {
            path: "/special_students_archives",
            name: "special_students_archives",
            component: () =>
              import(
                "../views/school/safetyData/studentHealthManagement/SpecialStudentsArchives.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 学生心理健康档案
          {
            path: "/mental_health_archives",
            name: "mental_health_archives",
            component: () =>
              import(
                "../views/school/safetyData/studentHealthManagement/MentalHealthArchives.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 突发事件管理
          {
            path: "/emergency_management",
            name: "emergency_management",
            component: () =>
              import(
                "../views/school/safetyData/studentHealthManagement/EmergencyManagement.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 留守儿童档案
          {
            path: "/home_children_archives",
            name: "home_children_archives",
            component: () =>
              import(
                "../views/school/safetyData/studentHealthManagement/HomeChildrenArchives.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 定期家访管理
          {
            path: "/home_visit_management",
            name: "home_visit_management",
            component: () =>
              import(
                "../views/school/safetyData/studentHealthManagement/HomeVisitManagement.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          }
        ]
      },

      // 安全管理
      {
        path: "/security_management",
        name: "security_management",
        component: () =>
          import("../views/school/safetyManagement/SafetyManagement.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        },
        children: [
          // 待办事项
          {
            path: "/not_done_matter",
            name: "not_done_matter",
            component: () =>
              import("../views/school/safetyManagement/NotDoneMatter.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 专项检查
          {
            path: "/special_inspect",
            name: "special_inspect",
            component: () =>
              import("../views/school/safetyManagement/SpecialInspect.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 学校会议
          {
            path: "/school_meetings",
            name: "school_meetings",
            component: () =>
              import(
                "../views/school/safetyManagement/meetings/SchoolMeetings.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 教育局会议
          {
            path: "/education_bureau_meeting",
            name: "education_bureau_meeting",
            component: () =>
              import(
                "../views/school/safetyManagement/meetings/EducationBureauMeeting.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 食堂员工
          {
            path: "/canteen_staff",
            name: "canteen_staff",
            component: () =>
              import(
                "../views/school/safetyManagement/foodSafety/CanteenStaff.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 食堂信息
          {
            path: "/canteen_data",
            name: "canteen_data",
            component: () =>
              import(
                "../views/school/safetyManagement/foodSafety/CanteenData.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },
          // 食堂信息
          {
            path: "/canteen_data_new",
            name: "canteen_data_new",
            component: () =>
              import(
                "../views/school/safetyManagement/foodSafety/CanteenList.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },
          // 食堂信息
          {
            path: "/canteen_staff_list",
            name: "canteen_staff_list",
            component: () =>
              import(
                "../views/school/safetyManagement/foodSafety/StaffList.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 供应商
          {
            path: "/school_supplier",
            name: "school_supplier",
            component: () =>
              import(
                "../views/school/safetyManagement/foodSafety/SchoolSupplier.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 食品制度
          {
            path: "/food_system",
            name: "food_system",
            component: () =>
              import(
                "../views/school/safetyManagement/foodSafety/FoodSystem.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 食品制度模版
          {
            path: "/food_system_template",
            name: "food_system_template",
            component: () =>
              import(
                "../views/school/safetyManagement/foodSafety/FoodSystemTemplate.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },
          // 食品制度
          {
            path: "/task_issue",
            name: "task_issue",
            component: () =>
              import(
                "../views/school/safetyManagement/taskIssue/taskIssue.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 每周菜单
          {
            path: "/weekly_menu",
            name: "weekly_menu",
            component: () =>
              import(
                "../views/school/safetyManagement/foodSafety/WeeklyMenu.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 食品追溯
          {
            path: "/food_materials",
            name: "food_materials",
            component: () =>
              import(
                "../views/school/safetyManagement/foodSafety/FoodMaterials.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 留样管理
          {
            path: "/sample_management",
            name: "sample_management",
            component: () =>
              import(
                "../views/school/safetyManagement/foodSafety/SampleManagement.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 抽样检测
          {
            path: "/sampling_test",
            name: "sampling_test",
            component: () =>
              import(
                "../views/school/safetyManagement/foodSafety/SamplingTest.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 陪餐任务
          {
            path: "/meal_accompanying_task",
            name: "meal_accompanying_task",
            component: () =>
              import(
                "../views/school/safetyManagement/foodSafety/MealAccompanyingTask.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 陪餐记录
          {
            path: "/meal_accompanying_record",
            name: "meal_accompanying_record",
            component: () =>
              import(
                "../views/school/safetyManagement/foodSafety/MealAccompanyingRecord.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 食堂摄像头
          {
            path: "/canteen_camera",
            name: "canteen_camera",
            component: () =>
              import(
                "../views/school/safetyManagement/foodSafety/CanteenCamera.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 人脸布控
          {
            path: "/face_control",
            name: "face_control",
            component: () =>
              import(
                "../views/school/safetyManagement/foodSafety/FaceControl.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 报警设备
          {
            path: "/alarm_equipment",
            name: "alarm_equipment",
            component: () =>
              import(
                "../views/school/safetyManagement/foodSafety/AlarmEquipment.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 收件箱
          {
            path: "/inbox",
            name: "inbox",
            component: () =>
              import("../views/school/safetyManagement/Inbox.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 发信箱
          {
            path: "/send_mailbox",
            name: "send_mailbox",
            component: () =>
              import("../views/school/safetyManagement/SendMailbox.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 草稿箱
          {
            path: "/drafts",
            name: "drafts",
            component: () =>
              import("../views/school/safetyManagement/Drafts.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 整改通知
          {
            path: "/improving_notice",
            name: "improving_notice",
            component: () =>
              import("../views/school/safetyManagement/ImprovingNotice.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 问卷调查
          {
            path: "/questionnaire",
            name: "questionnaire",
            component: () =>
              import("../views/school/safetyManagement/Questionnaire.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 上级任务下发
          {
            path: "/superior_task_distribution",
            name: "superior_task_distribution",
            component: () =>
              import(
                "../views/school/safetyManagement/SuperiorTaskDistribution.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 学校工作任务
          {
            path: "/school_work_task",
            name: "school_work_task",
            component: () =>
              import("../views/school/safetyManagement/SchoolWorkTask.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 学校任务模版
          {
            path: "/school_task_template",
            name: "school_task_template",
            component: () =>
              import("../views/school/safetyManagement/SchoolTaskTemplate.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 安全教育计划
          {
            path: "/safety_education_program",
            name: "safety_education_program",
            component: () =>
              import(
                "../views/school/safetyManagement/SafetyEducationProgram.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 安全活动
          {
            path: "/safety_activities",
            name: "safety_activities",
            component: () =>
              import("../views/school/safetyManagement/SafetyActivotoes.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 上级下发制度
          {
            path: "/superior_system",
            name: "superior_system",
            component: () =>
              import("../views/school/safetyManagement/SuperiorSystem.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 学校制度
          {
            path: "/school_system",
            name: "school_system",
            component: () =>
              import("../views/school/safetyManagement/SchoolSystem.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 作业管理
          {
            path: "/homework_management",
            name: "homework_management",
            component: () =>
              import("../views/school/safetyManagement/HomeworkManagement.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 科目管理
          {
            path: "/subject_management",
            name: "subject_management",
            component: () =>
              import("../views/school/safetyManagement/SubjectManagement.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 一键报警
          {
            path: "/one_button_alarm",
            name: "one_button_alarm",
            component: () =>
              import("../views/school/safetyManagement/OneButtonAlarm.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          }
        ]
      },

      // 安全教育
      {
        path: "/safety_education",
        name: "safety_education",
        component: () =>
          import("../views/school/safetyEducation/SafetyEducation.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        },
        children: [
          // 安全知识库
          {
            path: "/public_safety_knowledge",
            name: "public_safety_knowledge",
            component: () =>
              import(
                "../views/school/safetyEducation/PublicSafetyKnowledge.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 安全课堂库
          {
            path: "/public_safety_course",
            name: "public_safety_course",
            component: () =>
              import("../views/school/safetyEducation/PublicSafetyCourse.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 精品安全知识库
          {
            path: "/excellen_safety_knowledge",
            name: "excellen_safety_knowledge",
            component: () =>
              import(
                "../views/school/safetyEducation/ExcellentSafetyKnowledge.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 精品安全知课堂
          {
            path: "/excellen_safety_course",
            name: "excellen_safety_course",
            component: () =>
              import(
                "../views/school/safetyEducation/ExcellentSafetyCourse.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 本地安全知识库
          {
            path: "/local_safety_knowledge",
            name: "local_safety_knowledge",
            component: () =>
              import(
                "../views/school/safetyEducation/LocalSafetyKnowledge.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 新增安全知识库
          {
            path: "/add_safety_knowledge",
            name: "add_safety_knowledge",
            component: () =>
              import(
                "../views/school/safetyEducation/addLocalSafetyKnowledge.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 本地安全知课堂
          {
            path: "/local_safety_course",
            name: "local_safety_course",
            component: () =>
              import("../views/school/safetyEducation/LocalSafetyCourse.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 资源分类
          {
            path: "/resource_classification",
            name: "resource_classification",
            component: () =>
              import(
                "../views/school/safetyEducation/ResourceClassification.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 安全教育视频
          {
            path: "/safety_education_video",
            name: "safety_education_video",
            component: () =>
              import(
                "../views/school/safetyEducation/SafetyEducationVideo.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 理论知识培训视频
          {
            path: "/knowledge_train_video",
            name: "knowledge_train_video",
            component: () =>
              import("../views/school/safetyEducation/KnowledgeTrainVideo.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 培训考核
          {
            path: "/QuestionBank",
            name: "QuestionBank",
            component: () =>
              import("../views/school/safetyEducation/QuestionBank.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 培训考核
          {
            path: "/SafetyPaper",
            name: "SafetyPaper",
            component: () =>
              import("../views/school/safetyEducation/SafetyPaper.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 测评记录
          {
            path: "/testRecord",
            name: "testRecord",
            component: () =>
              import("../views/school/safetyEducation/testRecord.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 双重知识库
          {
            path: "/training_check_video",
            name: "training_check_video",
            component: () =>
              import("../views/school/safetyEducation/TrainingCheckVideo.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 法治副教授课---人员简介
          {
            path: "/law_course_user",
            name: "law_course_user",
            component: () =>
              import("../views/school/safetyEducation/lawCourse/userList.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 法治副教授课---授课记录
          {
            path: "/prelection_record",
            name: "prelection_record",
            component: () =>
              import(
                "../views/school/safetyEducation/lawCourse/prelectionRecord.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          }
        ]
      },

      // 安全台账
      {
        path: "/safety_account",
        name: "safety_account",
        component: () =>
          import("../views/school/safetyAccount/SafetyAccout.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        },
        children: [
          // 日常数据统计
          {
            path: "/daily_patrol_statistics",
            name: "daily_patrol_statistics",
            component: () =>
              import("../views/school/safetyAccount/DailyPatrolStatistics.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 专项检查统计
          {
            path: "/special_inspection_statistics",
            name: "special_inspection_statistics",
            component: () =>
              import(
                "../views/school/safetyAccount/SpecialInspectionStatistics.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 安全隐患统计
          {
            path: "/hidden_danger_statistics",
            name: "hidden_danger_statistics",
            component: () =>
              import(
                "../views/school/safetyAccount/HiddenDangerStatistics.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 校际通知统计
          {
            path: "/notification_statistics",
            name: "notification_statistics",
            component: () =>
              import(
                "../views/school/safetyAccount/NotificationStatistics.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 安全评分
          {
            path: "/safety_score",
            name: "safety_score",
            component: () =>
              import("../views/school/safetyAccount/SafetyScore.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 学校安全报告
          {
            path: "/school_safety_report",
            name: "school_safety_report",
            component: () =>
              import("../views/school/safetyAccount/SchoolSafetyReport.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          }
        ]
      },

      // 出入管控
      {
        path: "/access_control",
        name: "access_control",
        component: () =>
          import("../views/school/accessControl/AccessControl.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        },
        children: [
          // 考勤规则
          {
            path: "/attendance_rule",
            name: "attendance_rule",
            component: () =>
              import("../views/school/accessControl/AttendanceRule.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },
          // 考勤记录
          {
            path: "/attendance_record",
            name: "attendance_record",
            component: () =>
              import("../views/school/accessControl/AttendanceRecord.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 访客机
          {
            path: "/visitor_machine",
            name: "visitor_machine",
            component: () =>
              import("../views/school/accessControl/VisitorMachine.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 被访老师人员
          {
            path: "/visiting_teachers",
            name: "visiting_teachers",
            component: () =>
              import("../views/school/accessControl/VisitingTeachers.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 临时访客
          {
            path: "/temporary_visitor",
            name: "temporary_visitor",
            component: () =>
              import("../views/school/accessControl/TemporaryVisitor.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 访客记录
          {
            path: "/visitor_record",
            name: "visitor_record",
            component: () =>
              import("../views/school/accessControl/VisitorRecord.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 访客人员
          {
            path: "/interviewed_person",
            name: "visitor_record",
            component: () =>
              import("../views/school/accessControl/InterviewedPerson.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 停车场绑定
          {
            path: "/car_park_binding",
            name: "car_park_binding",
            component: () =>
              import("../views/school/accessControl/CarParkBinding.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 车辆信息
          {
            path: "/car_info",
            name: "car_info",
            component: () =>
              import("../views/school/accessControl/CarInfo.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 车辆通行记录
          {
            path: "/vehicle_access_records",
            name: "vehicle_access_records",
            component: () =>
              import("../views/school/accessControl/VehicleAccessRecords.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 学生请假管理
          {
            path: "/student_leave_management",
            name: "student_leave_management",
            component: () =>
              import(
                "../views/school/accessControl/StudentLeaveManagement.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 黑名单管理
          {
            path: "/blacklist_management",
            name: "blacklist_management",
            component: () =>
              import("../views/school/accessControl/BlacklistManagement.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 人脸设备管理
          {
            path: "/face_device_management",
            name: "face_device_management",
            component: () =>
              import("../views/school/accessControl/FaceDeviceManagement.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 二维码考勤
          {
            path: "/qrcode_attendance_place",
            name: "qrcode_attendance_place",
            component: () =>
              import("../views/school/accessControl/QRcodeAttendancePlace.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 基础设置
          {
            path: "/basic_settings",
            name: "basic_settings",
            component: () =>
              import("../views/school/accessControl/BasicSettings.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          }
        ]
      },

      // 疫情防控
      {
        path: "/epidemic_prevention",
        name: "epidemic_prevention",
        component: () =>
          import("../views/school/epidemicPrevention/EpidemicPrevention.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        },
        children: [
          // 老师任务
          {
            path: "/teacher_task",
            name: "teacher_task",
            component: () =>
              import("../views/school/epidemicPrevention/TeacherTask.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 学生任务
          {
            path: "/student_task",
            name: "student_task",
            component: () =>
              import("../views/school/epidemicPrevention/StudentTask.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 教育局任务
          {
            path: "/education_bureau_task",
            name: "education_bureau_task",
            component: () =>
              import(
                "../views/school/epidemicPrevention/EducationBureauTask.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 任务模版
          {
            path: "/task_template",
            name: "task_template",
            component: () =>
              import("../views/school/epidemicPrevention/TaskTemplate.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 疫情防控风险点
          {
            path: "/risk_control_location",
            name: "risk_control_location",
            component: () =>
              import(
                "../views/school/epidemicPrevention/RiskControlLocation.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 系统风险点
          {
            path: "/system_risk_location",
            name: "system_risk_location",
            component: () =>
              import(
                "../views/school/epidemicPrevention/SystemRiskLocation.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 疫情防控知识
          {
            path: "/epidemic_prevention_knowledge",
            name: "epidemic_prevention_knowledge",
            component: () =>
              import(
                "../views/school/epidemicPrevention/EpidemicPreventionKnowledge.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 校园防控工作指引
          {
            path: "/epidemic_work_guide",
            name: "epidemic_work_guide",
            component: () =>
              import(
                "../views/school/epidemicPrevention/EpidemicWorkGuide.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 健康排查表
          {
            path: "/health_checklist",
            name: "health_checklist",
            component: () =>
              import("../views/school/epidemicPrevention/HealthChecklist.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 体温检测
          {
            path: "/temperature_testing",
            name: "temperature_testing",
            component: () =>
              import(
                "../views/school/epidemicPrevention/TemperatureTesting.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 晨午检
          {
            path: "/mn_testing",
            name: "mn_testing",
            component: () =>
              import("../views/school/epidemicPrevention/MnTesting.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          }
        ]
      },

      // 校园风采
      {
        path: "/campus_style",
        name: "campus_style",
        component: () => import("../views/school/campusStyle/CampusStyle.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        },
        children: [
          // 校园动态
          {
            path: "/campus_dynamic",
            name: "campus_dynamic",
            component: () =>
              import("../views/school/campusStyle/CampusDynamic.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 教师风采
          {
            path: "/teacher_style",
            name: "teacher_style",
            component: () =>
              import("../views/school/campusStyle/TeacherStyle.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 班级风采
          {
            path: "/class_style",
            name: "class_style",
            component: () =>
              import("../views/school/campusStyle/ClassStyle.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          }
        ]
      },

      // 护学岗
      {
        path: "/protect",
        name: "protect",
        component: () => import("../views/school/protect/Protect.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        },
        children: [
          //护学岗记录
          {
            path: "/protect",
            name: "protect",
            component: () => import("../views/school/protect/Protect.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          }
        ]
      },

      // 警校协作
      {
        path: "/extraProtect",
        name: "extraProtect",
        component: () => import("../views/school/extraProtect/index.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        },
        children: [
          //护学岗记录
          {
            path: "/extraProtect",
            name: "extraProtect",
            component: () => import("../views/school/extraProtect/record.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },
          // 警校互动
          {
            path: "/extraInteract",
            name: "extraInteract",
            component: () =>
              import("../views/school/extraProtect/interact.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          }
        ]
      },

      // 校长专栏
      {
        path: "/principalColumn",
        name: "principalColumn",
        component: () => import("../views/school/principalColumn/index.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        },
        children: [
          //校长专栏
          {
            path: "/principalColumn",
            name: "principalColumn",
            component: () => import("../views/school/principalColumn/index.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          }
        ]
      },
      {
        path: "/Visualization",
        name: "Visualization",
        component: () =>
          import(
            "../views/school/customVideo/index.vue"
          ),
        meta: {
          title: "", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        }
      },
     
      {
        path: "/cloud_meeting",
        name: "cloud_meeting",
        component: () =>
          import(
            "../views/school/cloudMeeting/school.vue"
          ),
        meta: {
          title: "云上会议", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        }
      },
      {
        path: "/small_course",
        name: "small_course",
        component: () =>
          import(
            "../views/school/smallCourse/index.vue"
          ),
        meta: {
          title: "安全教育微课助手", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        }
      },
      //
      {
        path: "/cloudDevice",
        name: "cloudDevice",
        component: () => import("../views/school/device/index.vue"),
        meta: {
          title: "云广播", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        },
        children: [
          //
          {
            path: "/cloudDevice",
            name: "cloudDevice",
            component: () => import("../views/school/device/list.vue"),
            meta: {
              title: "设备列表", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },
          
        ]
      },
      {
        path: "/cloudResources",
        name: "cloudResources",
        component: () => import("../views/school/device/resource.vue"),
        meta: {
          title: "云广播", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        },
        children: [
          //
          {
            path: "/cloudResources",
            name: "cloudResources",
            component: () => import("../views/school/device/resource.vue"),
            meta: {
              title: "设备资源", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },
          
        ]
      },
      {
        path: "/cloudTaskList",
        name: "cloudTaskList",
        component: () => import("../views/school/device/taskList.vue"),
        meta: {
          title: "任务管理", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        },
        children: [
          //
          {
            path: "/cloudTaskList",
            name: "cloudTaskList",
            component: () => import("../views/school/device/taskList.vue"),
            meta: {
              title: "任务管理", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },
          
        ]
      },
      {
        path: "/relaxTimeSet",
        name: "relaxTimeSet",
        component: () => import("../views/school/device/relaxTimeSet.vue"),
        meta: {
          title: "作息设置", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        },
        children: [
          //
          {
            path: "/relaxTimeSet",
            name: "relaxTimeSet",
            component: () => import("../views/school/device/relaxTimeSet.vue"),
            meta: {
              title: "作息设置", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },
          
        ]
      },
      {
        path: "/cloudPlan",
        name: "cloudPlan",
        component: () => import("../views/school/device/plan.vue"),
        meta: {
          title: "云广播", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        },
        children: [
          //
          {
            path: "/cloudPlan",
            name: "cloudPlan",
            component: () => import("../views/school/device/plan.vue"),
            meta: {
              title: "应急预案", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },
          
        ]
      },
      
      // {
      //   path: "/cloudResources",
      //   name: "cloudResources",
      //   component: () => import("../views/school/device/resource.vue"),
      //   meta: {
      //     title: "设备资源", // 标题
      //     isLogin: true, // 是否要登录
      //     webType: 1 // 页面归类,1学校，2教育局
      //   }
      // }

      // 心理健康
      {
        path: "/psychology",
        name: "psychology",
        component: () => import("../views/school/psychology/index.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        },
        children: [
          {
            path: "/psychology",
            name: "psychology",
            component: () => import("../views/school/psychology/info.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          }
        ]
      },

      //安全物联
      {
        path: "/network_equipment",
        name: "network_equipment",
        component: () =>
          import("../views/school/safetyNetworkEquipment/NetworkEquipment.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        },
        children: [
          //教程管理
          {
            path: "/generation_number",
            name: "generation_number",
            component: () =>
              import(
                "../views/school/safetyNetworkEquipment/GenerationNumber.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },
          //安全巡视
          {
            path: "/safety_inspection",
            name: "safety_inspection",
            component: () =>
              import(
                "../views/school/safetyNetworkEquipment/SafetyInspection.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },
          //摄像头列表
          {
            path: "/camera_list",
            name: "camera_list",
            component: () =>
              import("../views/school/safetyNetworkEquipment/CameraList.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },
          //监控权限信息
          {
            path: "/monitors_power_info",
            name: "monitors_power_info",
            component: () =>
              import(
                "../views/school/safetyNetworkEquipment/MonitorsPowerInfo.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          //监控区域管理
          {
            path: "/regional_management",
            name: "regional_management",
            component: () =>
              import(
                "../views/school/safetyNetworkEquipment/RegionalManagement.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          //视频告警管理
          {
            path: "/video_warning_management",
            name: "video_warning_management",
            component: () =>
              import(
                "../views/school/safetyNetworkEquipment/VideoWarningManagement.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          //视频报警记录
          {
            path: "/video_alarm_record",
            name: "video_alarm_record",
            component: () =>
              import(
                "../views/school/safetyNetworkEquipment/VideoAlarmRecord.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          //视频报警记录
          {
            path: "/monitor_face_manage",
            name: "monitor_face_manage",
            component: () =>
              import(
                "../views/school/safetyNetworkEquipment/MonitorFaceManage.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 安全用-电设备管理
          {
            path: "/electricity_device_management",
            name: "electricity_device_management",
            component: () =>
              import(
                "../views/school/safetyNetworkEquipment/ElectricityDeviceManagement.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 用电检测
          {
            path: "/electricity_detection",
            name: "electricity_detection",
            component: () =>
              import(
                "../views/school/safetyNetworkEquipment/ElectricityDetection.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 安全用电-报警管理
          {
            path: "/electricity_alarm_management",
            name: "electricity_alarm_management",
            component: () =>
              import(
                "../views/school/safetyNetworkEquipment/ElectricityAlarmManagement.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 智慧消防-设备管理
          {
            path: "/protect_device_management",
            name: "protect_device_management",
            component: () =>
              import(
                "../views/school/safetyNetworkEquipment/ProtectDeviceManagement.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },
           // 智慧消防-千里眼设备管理
           {
             path: "/protect_thousand_management",
             name: "protect_thousand_management",
             component: () =>
               import(
                   "../views/school/safetyNetworkEquipment/ProtectThousandManagement.vue"
               ),
             meta: {
               title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
               isLogin: true, // 是否要登录
               webType: 1 // 页面归类,1学校，2教育局
             }
           },
          // 智慧消防-报警管理
          {
            path: "/protect_alarm_management",
            name: "protect_alarm_management",
            component: () =>
              import(
                "../views/school/safetyNetworkEquipment/ProtectAlarmManagement.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // ISC-设备管理
          {
            path: "/isc_device_management",
            name: "isc_device_management",
            component: () =>
              import(
                "../views/school/safetyNetworkEquipment/IscDeviceManagement.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 校园门禁管理
          {
            path: "/access_control_management",
            name: "access_control_management",
            component: () =>
              import(
                "../views/school/safetyNetworkEquipment/AccessControlManagement.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 报警主机-设备管理
          {
            path: "/host_device_management",
            name: "host_device_management",
            component: () =>
              import(
                "../views/school/safetyNetworkEquipment/HostDeviceManagement.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 报警主机-报警管理
          {
            path: "/host_alarm_management",
            name: "host_alarm_management",
            component: () =>
              import(
                "../views/school/safetyNetworkEquipment/HostAlarmManagement.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 空气质量检查管理
          {
            path: "/air_quality_inspection",
            name: "air_quality_inspection",
            component: () =>
              import(
                "../views/school/safetyNetworkEquipment/AirQualityInspection.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 今日广播
          {
            path: "/today_broadcast",
            name: "today_broadcast",
            component: () =>
              import(
                "../views/school/safetyNetworkEquipment/TodayBroadcast.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 作息广播
          {
            path: "/rest_broadcast",
            name: "rest_broadcast",
            component: () =>
              import(
                "../views/school/safetyNetworkEquipment/RestBroadcast.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 作息广播设置
          {
            path: "/rest_broadcast_settings",
            name: "rest_broadcast_settings",
            component: () =>
              import(
                "../views/school/safetyNetworkEquipment/RestBroadcastSettings.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 作息广播任务设置
          {
            path: "/rest_broadcast_settings_Task",
            name: "rest_broadcast_settings_Task",
            component: () =>
              import(
                "../views/school/safetyNetworkEquipment/RestBroadcastSettingsTask.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 校园定时广播
          {
            path: "/time_broadcast",
            name: "time_broadcast",
            component: () =>
              import(
                "../views/school/safetyNetworkEquipment/TimeBroadcast.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          //监控列表
          {
            path: "/monitor_list",
            name: "monitor_list",
            component: () =>
              import("../views/school/safetyNetworkEquipment/MonitorList.vue"),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          //校园广播绑定
          {
            path: "/broadcast_binding",
            name: "broadcast_binding",
            component: () =>
              import(
                "../views/school/safetyNetworkEquipment/BroadcastBinding.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          //获取广播控制器下广播分区
          {
            path: "/broadcastController",
            name: "broadcastController",
            component: () =>
              import(
                "../views/school/safetyNetworkEquipment/BroadcastController.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          //获取广播控制器下广播分区
          {
            path: "/broadcastEquipment",
            name: "broadcastEquipment",
            component: () =>
              import(
                "../views/school/safetyNetworkEquipment/BroadcastEquipment.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          //校园广播分组
          {
            path: "/broadcast_group",
            name: "broadcast_group",
            component: () =>
              import(
                "../views/school/safetyNetworkEquipment/BroadcastGroup.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          //广播资源
          {
            path: "/broadcast_resources",
            name: "broadcast_resources",
            component: () =>
              import(
                "../views/school/safetyNetworkEquipment/BroadcastResources.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          //系统广播
          {
            path: "/system_broadcast",
            name: "system_broadcast",
            component: () =>
              import(
                "../views/school/safetyNetworkEquipment/SystemBroadcast.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          //播放记录
          {
            path: "/broadcast_play_record",
            name: "broadcast_play_record",
            component: () =>
              import(
                "../views/school/safetyNetworkEquipment/BroadcastPlayRecord.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 体温报表
          {
            path: "/temperature_statements",
            name: "temperature_statements",
            component: () =>
              import(
                "../views/school/safetyNetworkEquipment/TemperatureStatements.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },

          // 异常统计
          {
            path: "/abnormal_statistics",
            name: "abnormal_statistics",
            component: () =>
              import(
                "../views/school/safetyNetworkEquipment/AbnormalStatistics.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          }
        ]
      },
      //平安家校
      {
        path: "/safety_home_school",
        name: "network_equipment",
        component: () =>
          import("../views/school/SafetyHomeSchool/SchoolBusManage/index.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        },
        children: [
          //校车路线管理
          {
            path: "/the_bus_route_manage",
            name: "the_bus_route_manage",
            component: () =>
              import(
                "../views/school/SafetyHomeSchool/SchoolBusManage/TheBusRouteManage.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },
          //校车司机管理
          {
            path: "/school_bus_driver_manage",
            name: "school_bus_driver_manage",
            component: () =>
              import(
                "../views/school/SafetyHomeSchool/SchoolBusManage/SchoolBusDriverManage.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },
          //随车人员管理
          {
            path: "/car_following_manage",
            name: "car_following_manage",
            component: () =>
              import(
                "../views/school/SafetyHomeSchool/SchoolBusManage/CarFollowingManage.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          }
        ]
      },
      //环境检测管理
      {
        path: "/environment_detection",
        name: "environment_detection",
        component: () =>
          import("../views/school/environmentDetection/index.vue"),
        meta: {
          title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        },
        children: [
          //环测设备管理
          {
            path: "/e_equipment_list",
            name: "equipment_list",
            component: () =>
              import(
                "../views/school/environmentDetection/equipment/equipmentList.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          },
          //环测设备报警
          {
            path: "/a_alarm_list",
            name: "a_alarm_list",
            component: () =>
              import(
                "../views/school/environmentDetection/alarm/alarmList.vue"
              ),
            meta: {
              title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
              isLogin: true, // 是否要登录
              webType: 1 // 页面归类,1学校，2教育局
            }
          }
        ]
      }
    ]
  },

  //安全态势---大数据中心-v1
  {
    path: "/big_data",
    name: "big_data",
    component: () => import("../views/school/bigData/v1/index.vue"),
    meta: {
      title: "大数据中心", // 标题
      isLogin: true, // 是否要登录
      webType: 1 // 页面归类,1学校，2教育局
    },
    children: [
      //基础信息
      {
        path: "/basics_info",
        name: "basics_info",
        component: () => import("../views/school/bigData/v1/basicsInfo.vue"),
        meta: {
          title: "基础信息", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        }
      },
      //基础信息(安全数据)
      {
        path: "/basics_info_safe",
        name: "basics_info_safe",
        component: () => import("../views/school/bigData/v1/basicsInfo/index.vue"),
        meta: {
          title: "基础信息", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        }
      },
      //风险隐患
      {
        path: "/risk_hidden_danger",
        name: "risk_hidden_danger",
        component: () => import("../views/school/bigData/v1/riskHiddenDanger.vue"),
        meta: {
          title: "风险隐患", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        }
      },
      //监控中心
      {
        path: "/monitoring_center",
        name: "monitoring_center",
        component: () => import("../views/school/bigData/v1/monitoringCenter.vue"),
        meta: {
          title: "雪亮工程", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        }
      },
      //安全地图
      {
        path: "/safety_map_data",
        name: "safety_map_data",
        component: () => import("../views/school/bigData/v1/safetyMap.vue"),
        meta: {
          title: "安全地图", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        }
      },
      //食品安全
      {
        path: "/food_safety_data",
        name: "food_safety_data",
        component: () => import("../views/school/bigData/v1/foodSafety.vue"),
        meta: {
          title: "食品安全", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        }
      }
    ]
  },
  //安全态势---大数据中心-v2
  {
    path: "/big_data_2",
    name: "big_data_2",
    component: () => import("../views/school/bigData/v2/index.vue"),
    meta: {
      title: "大数据中心", // 标题
      isLogin: true, // 是否要登录
      webType: 1 // 页面归类,1学校，2教育局
    },
    children: [
      //基础信息
      {
        path: "/basics_info_2",
        name: "basics_info_2",
        component: () => import("../views/school/bigData/v2/basicsInfo.vue"),
        meta: {
          title: "基础信息", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        }
      },
      //风险隐患
      {
        path: "/risk_hidden_danger_2",
        name: "risk_hidden_danger_2",
        component: () => import("../views/school/bigData/v2/riskHiddenDanger.vue"),
        meta: {
          title: "风险隐患", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        }
      },
      //监控中心
      {
        path: "/monitoring_center_2",
        name: "monitoring_center_2",
        component: () => import("../views/school/bigData/v2/monitoringCenter.vue"),
        meta: {
          title: "雪亮工程", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        }
      },
      //安全地图
      {
        path: "/safety_map_data_2",
        name: "safety_map_data_2",
        component: () => import("../views/school/bigData/v2/safetyMap.vue"),
        meta: {
          title: "安全地图", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        }
      },
      //食品安全
      {
        path: "/food_safety_data_2",
        name: "food_safety_data_2",
        component: () => import("../views/school/bigData/v2/foodSafety.vue"),
        meta: {
          title: "食品安全", // 标题
          isLogin: true, // 是否要登录
          webType: 1 // 页面归类,1学校，2教育局
        }
      },
      
    ]
  },

  //应急演练中心
  {
    path: "/drill_center",
    name: "drill_center",
    component: () =>
      import("../views/school/emergencyTreatment/DrillCenter.vue"),
    meta: {
      title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
      isLogin: true, // 是否要登录
      webType: 1 // 页面归类,1学校，2教育局
    }
  },

  // 校园安全大数据平台-v1
  {
    path: "/safeposture_school",
    name: "safeposture_school",
    component: () =>
      import("../views/school/bigDataSafety/v1/SafepostureSchool.vue"),
    meta: {
      title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
      isLogin: true, // 是否要登录
      webType: 1 // 页面归类,1学校，2教育局
    }
  },
  // 校园安全大数据平台-v2
  {
    path: "/safeposture_school_2",
    name: "safeposture_school_2",
    component: () =>
      import("../views/school/bigDataSafety/v2/SafepostureSchool.vue"),
    meta: {
      title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
      isLogin: true, // 是否要登录
      webType: 1 // 页面归类,1学校，2教育局
    }
  },

  //环测设备状态
  {
    path: "/e_equipment_status",
    name: "e_equipment_status",
    component: () =>
      import(
        "../views/school/environmentDetection/equipment/equipmentStatus.vue"
      ),
    meta: {
      title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
      isLogin: true, // 是否要登录
      webType: 1 // 页面归类,1学校，2教育局
    }
  },

  //用户登录
  {
    path: "/login",
    name: "login",
    component: () => import("../views/Login.vue"),
    // component: () => import('../views/LoginTuDing.vue'),
    meta: {
      title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
      isLogin: false // 是否要登录
    }
  },
  //用户登录
  {
    path: "/wxScanLogin",
    name: "wxScanLogin",
    component: () => import("../views/wxScanLogin.vue"),
    // component: () => import('../views/LoginTuDing.vue'),
    meta: {
      title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
      isLogin: false // 是否要登录
    }
  },
  //页面走丢了
  {
    path: "/noData",
    name: "noData",
    component: () => import("../components/NoData.vue"),
    // component: () => import('../views/LoginTuDing.vue'),
    meta: {
      title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
      isLogin: false // 是否要登录
    }
  },

  //忘记密码
  {
    path: "/forget_password",
    name: "forget_password",
    component: () => import("../views/ForgetPassword.vue"),
    // component: () => import('../views/LoginTuDing.vue'),
    meta: {
      title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
      isLogin: false // 是否要登录
    }
  },

  // 金水区教育局跳转登录过度页面
  {
    path: "/JinShuiTemp",
    name: "JinShuiTemp",
    component: () => import("../components/JinShuiTemp.vue"),
    // component: () => import('../views/LoginTuDing.vue'),
    meta: {
      title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
      isLogin: false // 是否要登录
    }
  },

  // 分音塔大数据页面
  {
    path: "/fenYinTa",
    name: "fenYinTa",
    component: () => import("../views/edu/fenYinTa/bigData/index.vue"),
    // component: () => import('../views/LoginTuDing.vue'),
    meta: {
      title: "安全风险辨识管控与隐患排查治理双重预防体系云平台", // 标题
      isLogin: false // 是否要登录
    }
  },
  {
    path: "/meeting_online",
    name: "meeting_online",
    component: () =>
      import(
        "../views/school/cloudMeeting/online.vue"
      ),
    meta: {
      title: "云上会议", // 标题
      isLogin: true, // 是否要登录
      webType: 1 // 页面归类,1学校，2教育局
    }
  },

  {
    path: "/CloudDrillCenter",
    name: "CloudDrillCenter",
    component: () => import("../views/school/emergencyTreatment/CloudDrillCenter.vue"),        
    meta: {
      title: "应急预案指挥中心", // 标题
      isLogin: true, // 是否要登录
      webType: 1 // 页面归类,1学校，2教育局
    },
    // children: [
    //   //
    //   {
    //     path: "/CloudDrillCenter",
    //     name: "CloudDrillCenter",
    //     component: () => import("../views/school/emergencyTreatment/CloudDrillCenter.vue"),    
    //     meta: {
    //       title: "应急预案指挥中心", // 标题
    //       isLogin: true, // 是否要登录
    //       webType: 1 // 页面归类,1学校，2教育局
    //     }
    //   },
      
    // ]
  },
];

const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
});

const vueObject = new Vue({
  store
});
NProgress.inc(0.2);
NProgress.configure({
  easing: "ease",
  speed: 500,
  showSpinner: false
});
router.beforeEach((to, from, next) => {
  if(to.path==from.path){
    next(false);
  }
  NProgress.start();
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  // 页面走丢了  404
  if (to.name == null) {
    next({
      path: "/noData"
    });
    return;
  }

  // console.log(to.meta.isLogin)
  // console.log(vueObject.$store.state.userInfo)

  // sessionStorage.setItem('thisOnePagePath', to.fullPath)
  // sessionStorage.setItem('thisLeftPagePath', to.fullPath)
  // sessionStorage.setItem('thisTopPagePath', to.fullPath)
  // sessionStorage.setItem('thisSituationPagePath', to.fullPath)

  // if(!to.query.code && to.meta.isLogin == true && vueObject.$store.state.userInfo==false){
  //     next({
  //         path: "/login"
  //     })
  //     sessionStorage.setItem('thisOnePagePath', '/login')
  //     return;
  // }
  if (to.meta.isLogin == true && vueObject.$store.state.userInfo == false) {
    next({
      path: "/login"
    });
    sessionStorage.setItem("thisOnePagePath", "/login");
    return;
  }

  if (to.fullPath == "/") {
    if (vueObject.$store.getters.getUserInfo.eduId == 0) {
      let schoolPath = '/schoolIndex_' + vueObject.$store.state.schoolBidDataVersion;
      next({
        path: schoolPath
      });
      // sessionStorage.setItem('thisOnePagePath', '/schoolIndex')
      return;
    }
    next({
      path: "/eduIndex"
    });
    // sessionStorage.setItem('thisOnePagePath', '/eduIndex')
    return;
    // console.log(vueObject.$store.getters.getUserInfo.eduId)
    // if(vueObject.$store.getUserInfo.eduId)
  }
  next();
});
router.afterEach(() => {
  NProgress.done();
});
export default router;
